module.exports = __webpack_public_path__ + "static/media/web_header_01.99f29411.webp";